import { formatClock } from '../../liveSession/lib/roundClock';
import { mapKey } from './playbook';
import type { StrategyDetail } from '../types';

export function activationProblems(detail: StrategyDetail): string[] {
  const problems: string[] = [];
  const name = detail.name.trim();
  if (!name || name === 'Untitled strategy') problems.push('Give the strategy a name.');
  if (!detail.strategyType?.trim()) problems.push('Choose a type.');
  if (detail.roles.length === 0) problems.push('Add at least one role.');
  if (detail.roles.some((role) => !role.name.trim())) problems.push('Every role needs a name.');

  for (const role of detail.roles) {
    const who = role.name.trim() || 'Role';
    for (const action of role.actions) {
      if (action.actionType.trim().toLowerCase() !== 'utility') continue;
      const clock = formatClock(action.roundTimeSecs);
      if (!action.utilityUse) {
        problems.push(`${who}: choose a lineup for the utility at ${clock}.`);
        continue;
      }
      if (action.utilityUse.map && mapKey(action.utilityUse.map) !== mapKey(detail.map)) {
        problems.push(`${who}: the lineup at ${clock} is for another map.`);
      }
    }
  }
  return problems;
}

export function authoringWarnings(detail: StrategyDetail): string[] {
  const warnings: string[] = [];
  if (detail.planSteps.length === 0) warnings.push('The round plan is empty.');
  if (!detail.description?.trim()) warnings.push('Add a description.');
  if (!detail.site?.trim()) warnings.push('Name the site.');
  const names = detail.roles.map((role) => role.name.trim().toLowerCase()).filter(Boolean);
  if (new Set(names).size !== names.length) warnings.push('Two roles share a name.');
  for (const role of detail.roles) {
    const who = role.name.trim() || 'Role';
    if (role.actions.length === 0) warnings.push(`${who} has no actions.`);
    for (const action of role.actions) {
      if (action.actionType.trim().toLowerCase() === 'hold' && action.durationSecs == null) {
        warnings.push(`${who}: the hold at ${formatClock(action.roundTimeSecs)} has no duration.`);
      }
    }
  }
  return warnings;
}
